import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MyAccountAction from '../actions/MyAccountAction';
import UpdatePayment from '../../components/myaccount/UpdatePayment/UpdatePayment';

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    checkSession: MyAccountAction.checkSession
  }, dispatch);


const UpdatePaymentContainer = connect(null, mapDispatchToProps)(UpdatePayment);

export default UpdatePaymentContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/UpdatePaymentContainer.js
 **/